// extracted by mini-css-extract-plugin
export var btn = "R_mB G_vJ G_vy d_bz d_bP d_bD d_dw";
export var full = "R_wT d_w d_H";
export var hoverStyle = "R_mF";
export var zoom = "R_mG";